import React, { useState, useEffect, useCallback, useMemo } from "react";
import SidebarTableSelector from "../components/SidebarTableSelector";
import SidebarDatasetSelector from "../components/SidebarDatasetSelector"; 
import JoinConfigurator from "../components/JoinConfigurator";
import PreviewPanel from "../components/DatatablePreviewPanel";
import SavedQueryManager from "../components/SavedQueryManager"; 
import ConditionGroup from "../components/ConditionGroup";
import axios from "axios";
import endpoints from "../config";
import { toast } from "react-toastify"; 
import FullPageLoader from "../components/FullPageLoader";
import ColumnSelector from "../components/ColumnSelector"; 
import SegmentInput from "../components/SegmentInput";
import DescriptionInput from "../components/DescriptionInput";
import CustomSegmentModal from "../components/CustomSegmentModal";
import { useAuth } from "../context/AuthContext";
const AdvanceGroupQueryBuilder = () => {
  const {authToken,logout} = useAuth();

  // Memoize headers so it doesn't change on every render
  const headers = useMemo(() => ({
    Authorization: `Bearer ${authToken}`
  }), [authToken]);
  const [customSegmentModal, setCustomSegmentModal] = useState(false); 
  const [selectedColumns, setSelectedColumns] = useState([]); 
  // const headers = { Authorization: `Bearer ${authToken}` };
  const [datasets, setDatasets] = useState([]);
  const [tables, setTables] = useState([]);
  const [columns, setColumns] = useState([]);
  const [selectedDataset, setSelectedDataset] = useState("brps_cdp_curated");
  // const [selectedTable, setSelectedTable] = useState("");
  const [loadQueryData, setLoadQueryData] = useState(false);
  const [selectedTables, setSelectedTables] = useState([]);
  const [joins, setJoins] = useState([]);
  const [previewData, setPreviewData] = useState(null);
  const [savedQueries, setSavedQueries] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 500000, total: 0 });
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [segmentName, setSegmentName] = useState("");
  const [segmentSaveLoading, setSegmentSaveLoading] = useState(false);
  const [segmentQueryID, setSegmentQueryID] = useState("");

  const [conditionGroup, setConditionGroup] = useState({ operator: "AND", conditions: [] });
  const [segmentDescription, setSegmentDescription] = useState("");

  // Memoize loadDatasetTables so it doesn't change on every render
  const loadDatasetTables = useCallback(() => {
    setLoading(true);
    axios.get(`${endpoints.queries.tables}${selectedDataset}`, { headers })
      .then(res => setTables(res.data))
      .catch(() => toast.error("Failed to select option."))
      .finally(() => setLoading(false));
  }, [selectedDataset, headers]);

  
 
  const handleDatasetChange = (ds) => {
    setSelectedDataset(ds);
    // setSelectedTable("");
    setSelectedTables([]);
    setColumns([]);

    axios.get(`${endpoints.queries.tables}${ds}`, { headers })
      .then(res => setTables(res.data))
      .catch(() => toast.error("Failed to select option."));
  };

  const handleAddJoin = () => {
    setJoins([...joins, { type: "INNER", from: "", to: "" }]);
  };

  const handleRemoveJoin = (index) => {
    const newJoins = joins.filter((_, i) => i !== index);
    setJoins(newJoins);
  };
  const resetQueryBuilder = ()=>{
    // reset joins and query builder
      setJoins([]);
      setConditionGroup({ operator: "AND", conditions: [] });
  }
  const handleTableToggle = async (table) => {

    const isSelected = selectedTables.includes(table);
    const updatedTables = isSelected ? selectedTables.filter(t => t !== table) : [...selectedTables, table];

    setSelectedTables(updatedTables);
    setSegmentQueryID("")
    try {
      const columnRequests = updatedTables.map(tb =>
        axios.get(`${endpoints.queries.columns}${selectedDataset}/${tb}`, { headers })
      );
      const responses = await Promise.all(columnRequests);
      const allColumns = responses
        .map((res, i) => res.data.map(col => `${updatedTables[i]}.${col}`))
        .flat();
      const uniqueColumns = Array.from(new Set(allColumns));
      setColumns(uniqueColumns);
      setSelectedColumns(uniqueColumns); 
    } catch (err) {
      toast.error("Failed to load columns for selected tables.");
    }
  };

  const handleUpdateJoin = (index, updatedJoin) => {
    const newJoins = [...joins];
    newJoins[index] = updatedJoin;
    setJoins(newJoins);
  };

  const handlePreview = useCallback((page = 1) => {
  const limit = pagination.limit; // capture it at the start

  if (selectedTables.length > 1 && joins.length === 0) {
    toast.error("Please configure join(s) between selected tables.");
    return;
  }

  if (selectedColumns.length === 0) {
    toast.error("Please select at least one column to preview.");
    return;
  }

  const payload = {
    dataset: selectedDataset,
    tables: selectedTables,
    joins,
    conditions: conditionGroup,
    columns: selectedColumns,
    limit,
    page,
    qid:segmentQueryID
  };

  setLoading(true);
  axios.post(endpoints.queries.advanceGroupPreview, payload, { headers })
    .then(res => {
      setPreviewData(res.data);
      setLoadQueryData(false); 
      if (!res.data.rows || res.data.rows.length === 0) {
        toast.warning("No records found!");
      } else {
        
        if (segmentQueryID && res.data?.description.length>4){
          setSegmentDescription(res.data?.description);
        } else if(res.data?.cond || res.data?.joins){ 
                let desc = `View${selectedTables.length > 1 ? 's' : ''}: ${selectedTables.join(',')}`; 
                if (res.data?.joins?.trim()) {
                  desc += `\nJoins: ${res.data?.joins}`;
                } 
                if (res.data?.cond?.trim()) {
                  desc += `\nCondition: ${res.data?.cond}`;
                }  
                setSegmentDescription(desc);
        }
        setShowPreviewModal(true);
      }

      setPagination(prev => ({ ...prev, page, total: res.data.total }));
    })
    .catch(err => toast.error(err?.response?.data?.detail?.error || "Preview failed due to server error."))
    .finally(() => setLoading(false));
}, [
  selectedTables,
  joins,
  selectedColumns,
  selectedDataset,
  conditionGroup,
  headers,
  pagination.limit, // safe to keep if captured as const
  segmentQueryID
]);

  
  const handleSaveQuery = (name) => {
    const payload = {
      name,
      query_type:'group',
      description:segmentDescription,
      query: JSON.stringify({
        dataset: selectedDataset,
        tables: selectedTables,
        joins,
        conditions: conditionGroup,
        columns: selectedColumns
      }),
    };
    return payload;
  };

const fetchSavedQueries = useCallback(() => {
  setLoading(true);
  axios.get(`${endpoints.queries.advanceSavedQueries}/group`, { headers })
    .then(res => setSavedQueries(res.data))
    .catch(err => { 
      toast.error(err?.response?.data?.detail || "Failed to load saved queries");
    })
    .finally(() => setLoading(false)); 
}, [headers]);


  const handleLoadQuery = async (id) => {
    try {
      setLoading(true)
      setSegmentQueryID(id)
      const res = await axios.get(`${endpoints.queries.advanceSavedQuery}${id}`, { headers });
      const parsedQuery = JSON.parse(res.data.query);

      setSelectedDataset(parsedQuery.dataset);
      setSelectedTables(parsedQuery.tables);
      // setSelectedTable(parsedQuery.tables);
      setJoins(parsedQuery.joins || []);
      setConditionGroup(parsedQuery.conditions || { operator: "AND", conditions: [] });
      setSelectedColumns(parsedQuery.columns || []); 
      const columnRequests = parsedQuery.tables.map(tb =>
        axios.get(`${endpoints.queries.columns}${parsedQuery.dataset}/${tb}`, { headers })
      );
      const responses = await Promise.all(columnRequests);
      const allColumns = responses
        .map((res, i) => res.data.map(col => `${parsedQuery.tables[i]}.${col}`))
        .flat();
      const uniqueColumns = Array.from(new Set(allColumns));
      setColumns(uniqueColumns);
      // setSelectedColumns(uniqueColumns);
      setLoadQueryData(true);
    } catch (error) {
      toast.error("Failed to load query.");
      setLoading(false)
    }
  };

  const handleDeleteQuery = async (id) => {
    try {
      setLoading(true)
      await axios.delete(`${endpoints.queries.deleteSavedQuery}${id}`, { headers });
      toast.success("Query deleted");
      fetchSavedQueries();
    } catch {
      toast.error("Failed to delete query");
      setLoading(false)
    }
  };

  const handlePreviewSaveSegment = async () => {
    if (!segmentName.trim()) {
      toast.warning("Please enter a segment name.");
      return;
    }
    setSegmentSaveLoading(true); // Start loader
    try {
      const payload = handleSaveQuery(segmentName);
      if (!payload || !payload.query) {
        toast.error("Unable to get query details.");
        return;
      }
      await axios.post(endpoints.queries.advanceSaveQuery, payload, { headers });
      toast.success("Segment saved successfully!");
      setSegmentName("");
      fetchSavedQueries();
    } catch (error) {
       if (error.response?.data?.detail?.error) {
              toast.error(error.response.data.detail.error);
              } else {
              if (error.response && error.response.status === 401) {
                logout();
              } else {
                toast.error('Failed to save segment');
              }
              }
     
    } finally {
      setSegmentSaveLoading(false); // Stop loader
    }
  };
   useEffect(() => {
     
    axios.get(endpoints.queries.datasets, { headers })
      .then(res => {
        setDatasets(res.data)
        loadDatasetTables()
        fetchSavedQueries()
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          logout()
        } else {
          toast.error('Failed to fetch datasets');
        }
      }).finally(() => setLoading(false));
  }, [headers, loadDatasetTables, fetchSavedQueries, logout]);


  useEffect(() => {
    if (loadQueryData) {
      loadDatasetTables()
      handlePreview();
    }
 }, [loadQueryData, loadDatasetTables, handlePreview]);
  return (
    <div className="container-fluid px-4 py-2 " style={{ backgroundColor: "#e7eee7" }}>
           {/* Centralized Heading and Subheading */}
      <div className="row d-none">
        <div className="col-12">
          <div className="text-center my-4">
            <h2 className="fw-bold text-black">Customer Segmentation Builder</h2>
            <p className=" text-sm">
              Create powerful customer segments with our intuitive query builder.<br />
              No technical knowledge required - just select, filter, and segment your audience.
            </p>
          </div>
        </div>
      </div> 
      {loading && <FullPageLoader />}
      
       <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 border rounded px-2 py-4 mt-3" style={{ backgroundColor: '#ebe19b24' }}>
       
        <div className="col mb-3">
          <h5  className="bg-secondary text-white px-2 py-2 border rounded">Data Sets <button
    className="btn btn-success btn-sm ml-3 d-none"
    onClick={() => setCustomSegmentModal(true)}
  >
     <i className="fa fa-plus" style={{ marginRight: '6px' }}></i> Segment
  </button></h5>
          <SidebarDatasetSelector
            datasets={datasets}
            selectedDataset={selectedDataset}
            onChange={handleDatasetChange}
          />
          {selectedDataset.length>0?<div className="mt-2" style={{ maxHeight: "350px", overflowY: "auto"}}>
            <h5 className="bg-secondary text-white px-2 py-2 border rounded"  style={{position: "sticky",top: 0,zIndex: 1}}>Tables</h5>
            <SidebarTableSelector
              tables={tables}
              selectedTables={selectedTables}
              onChange={handleTableToggle}
            />
          </div>:''}
        </div>
        <div className="col mb-3">
          {selectedTables.length>0?<ColumnSelector
          availableColumns={columns}
          selectedColumns={selectedColumns}
          onChange={setSelectedColumns}
        />:''}
        <SegmentInput
              value={segmentName}
              onChange={setSegmentName}
              onSave={handlePreviewSaveSegment}
              disabled={false}
              loading={segmentSaveLoading} // <-- Pass loading prop
            />
         <SavedQueryManager
                    savedQueries={savedQueries}
                    onSave={handleSaveQuery}
                    onLoad={handleLoadQuery}
                    onDelete={handleDeleteQuery}
                    fetchQueries={fetchSavedQueries}
                  /> 
        </div> 
        {selectedTables.length>0?
        <div className="col mb-3"  style={{ maxHeight: "600px", overflowY: "auto", paddingX: "10px" }}>
          <h4  className="bg-secondary text-white px-2 py-2 border rounded d-flex justify-content-between"><div>Query Builder</div> <button className="btn btn-primary ml-3 text-end" onClick={() => handlePreview()}>Preview</button></h4>
          <DescriptionInput
          value={segmentDescription}
          onChange={setSegmentDescription}
        />

          <ConditionGroup
            group={conditionGroup}
            setGroup={setConditionGroup}
            fields={columns}
            onReset = {resetQueryBuilder}
          />

          <h5>Join Configuration</h5>
          <JoinConfigurator
            joins={joins}
            onAddJoin={handleAddJoin}
            onRemoveJoin={handleRemoveJoin}
            onUpdateJoin={handleUpdateJoin}
          />

          <button className="btn btn-primary mt-3" onClick={() => handlePreview()}>Preview</button>
        </div>:''}
         
         
      </div>
      <CustomSegmentModal
        show={customSegmentModal}
        onClose={() => setCustomSegmentModal(false)}   
      />
      {showPreviewModal && (
  <div
  className="modal show fade d-block"
  tabIndex="-1"
  role="dialog"
  style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
>
  <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable modal-fullscreen-sm-down" role="document">
    <div className="modal-content" style={{ backgroundColor: "#e7eee7" }}>
      
      {/* Header */}
      <div className="modal-header d-flex justify-content-between align-items-center flex-wrap">
        <h5 className="modal-title bg-secondary text-white px-2 py-2 border rounded mb-2 mb-sm-0">
          📊 Preview Result ({pagination?.total || 0} records)
        </h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => setShowPreviewModal(false)}
        ></button>
      </div>

      {/* Body */}
      <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <div className="row g-3">
          <div className="col-12 col-md-8 offset-md-2">
            <DescriptionInput
              value={segmentDescription}
              onChange={setSegmentDescription}
            />
            <SegmentInput
              value={segmentName}
              onChange={setSegmentName}
              onSave={handlePreviewSaveSegment}
              disabled={false}
              loading={segmentSaveLoading}
            />
          </div>
        </div>

        <div className="mt-3">
          <PreviewPanel
            previewData={previewData}
            pagination={pagination}
            previewQuery={handlePreview}
            isSegment={false}
          />
        </div>
      </div>

      {/* Footer */}
      <div className="modal-footer flex-wrap">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => setShowPreviewModal(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

)}

    </div>
  );
};

export default AdvanceGroupQueryBuilder;
